import Vue from 'vue'
import http from '@/server'
Vue.prototype.$http = http
const vm = new Vue()
const SDK = require('../../assets/NIM/NIM_Web_SDK_v8.8.1.js')

const state = {
    imConfigInfo: {},
    nim: null,
    chatroom: null,
    IMMsgList: [],
    isHaveNewMsg: false,
    leftBarName: '',
    roleList: []
}

const mutations = {
    setImConfigInfo (state, imConfigInfo) {
        state.imConfigInfo = imConfigInfo
    },
    addnewInfoForAddressForImConfigInfo (state, address) {
        state.imConfigInfo = {
            ...state.imConfigInfo,
            ...address
        }
    },
    setNim (state, nim) {
        state.nim = nim
    },
    setChatroom (state, chatroom) {
        state.chatroom = chatroom
    },
    setIMMsgList(state, list) {
        state.IMMsgList = list
    },
    addIMMsg(state, msg) {
        try {
            state.IMMsgList.push(msg)
            Vue.bus.emit('chatRoomScrollBottom')
        } catch (error) {
            console.error(error);
        }
    },
    setIsHaveNewMsg(state, status) {
        state.isHaveNewMsg = status
    },
    setLeftBarName(state, status) {
        state.leftBarName = status
    },
    setRoleList(state, roleList) {
        state.roleList = roleList
    }
}

const actions = {
    // 获取im config 信息：
    async getImConfigInfo({ commit }, { adminUserId, liveId }) {
        return new Promise(async (resolve, reject) => {
            const result = await vm.$http.initWebIm({ adminUserId, liveId })
            if (result.code !== 200) return reject(result.msg)
            if (result.rt.resultStatus !== 1) return reject(result.rt.resultMessage)
            commit('setImConfigInfo', result.rt)
            resolve(result.rt)
        })
    },
    /**
      *  im初始化
      *  @param paramsInfo：其中有两个属性：一个是lcId，一个是cb
      */
    webImInit({ state, commit, dispatch }, paramsInfo) {
        let { appKey, accid, token, roomId } = state.imConfigInfo
        // 初始化网易im
        // 注意这里, 当引入的SDK文件是NIM_Web_NIM_v.js时，请通过 NIM.getInstance 来初始化；当引入的SDK文件为NIM_Web_SDK_v时，请使用 SDK.NIM.getInstance 来初始化。
        const nim = SDK.NIM.getInstance({
            debug: false, // 是否开启日志，将其打印到console。集成开发阶段建议打开。 process.env.NODE_ENV !== 'production'
            appKey: appKey,
            account: accid,
            token,
            db: false, // 若不要开启数据库请设置false。SDK默认为true。
            onconnect: onConnect,
            onwillreconnect: onWillReconnect,
            ondisconnect: onDisconnect,
            onerror: onError,
            onmsg: onMsg
        })
        commit('setNim', nim)
        function onConnect () {
            nim.getChatroomAddress({
                chatroomId: roomId,
                done: getChatroomAddressDone
            })
            function getChatroomAddressDone (error, obj) {
                commit('addnewInfoForAddressForImConfigInfo', obj.address)
                const chatroom = SDK.Chatroom.getInstance({
                    appKey,
                    account: accid,
                    token: token,
                    chatroomId: roomId,
                    chatroomAddresses: obj.address,
                    onconnect: onChatroomConnect,
                    onerror: onChatroomError,
                    onwillreconnect: onChatroomWillReconnect,
                    ondisconnect: onChatroomDisconnect,
                    // 消息
                    onmsgs: onChatroomMsgs
                })
                commit('setChatroom', chatroom)
                async function onChatroomConnect (obj) {
                    console.log('进入聊天室', 'obj:', obj)
                    // 连接成功后才可以发消息
                    dispatch('informServe4001INeed', paramsInfo.lcId)
                }
                function onChatroomWillReconnect (obj) {
                    // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
                    console.log('即将重连', obj)
                }
                function onChatroomDisconnect (error) {
                    // 此时说明 `SDK` 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
                    console.log('连接断开', error)
                }
                function onChatroomError (error, obj) {
                    console.log('发生错误', error, obj)
                }
                function onChatroomMsgs (msgs) {
                    console.log('收到聊天室消息', msgs)
                    ;(msgs || []).forEach((item) => {
                        item.text && dispatch('disposeMessage', {
                            cb: paramsInfo.cb,
                            data: JSON.parse((item.text) || '{}')
                        })
                    })
                }
            }
        
        }
        function onWillReconnect (obj) {
            // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
            console.log('即将重连')
            console.log(obj.retryCount)
            console.log(obj.duration)
        }
        function onDisconnect (error) {
            // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
            console.log('丢失连接', error)
        }
        function onError (error) {
            console.log(error)
        }
        function onMsg (msg) {
            console.log('收到网易IM消息onMsg', msg.scene, msg.type, msg)
        }
    },
    async informServe4001INeed({ commit, rootGetters }, lcId) {
        try {   
            // 需要通知获取4001：
            const userId = rootGetters['userInfo/userInfo'].userId
            const params = {
                mainLiveId: lcId,
                personTyp: '1'
            }
            if (userId) {
                Object.assign(params, {
                    requestUserId: userId
                })
            }
            console.log(params, 'need_4001_params')
            const result = await vm.$http.informServe4001INeed(params)
            if (result.code !== 200) return
            const { rt: resultReally } = result
            if (!resultReally) return
            if (resultReally.resultStatus !== 1) return
        } catch (err) {
            console.log(err)
        }
    },
    disposeMessage({}, { cb, data }) {
        cb && cb(data)
    },
}

const getters = {
    getImConfigInfo(state) {
        return state.imConfigInfo
    },
    getIMMsgList(state) {
        return state.IMMsgList || []
    },
    getIsHaveNewMsg(state) {
        return state.isHaveNewMsg
    },
    getLeftBarName(state) {
        return state.leftBarName
    },
    getRoleList(state) {
        return state.roleList
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}